import Vue from 'vue'
import Router from 'vue-router'

import Front from '@/components/front/Front'

import Login from '@/components/login/Login'
import Home from '@/components/home/Home'
import Idus_in_stock from '@/components/in_stock/Idus_in_stock'
import S_in_stock from '@/components/in_stock/S_in_stock'
import Idus_out_stock from '@/components/out_stock/Idus_out_stock'
import S_out_stock from '@/components/out_stock/S_out_stock'
import S_stock from '@/components/select_stock/S_stock'
import Idus_stock from '@/components/select_stock/Idus_stock'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/Front',
      name: 'Front',
      component: Front
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/Idus_in_stock',
      name: 'Idus_in_stock',
      component: Idus_in_stock
    }
    ,
    {
      path: '/S_in_stock',
      name: 'S_in_stock',
      component: S_in_stock
    },

    {
      path: '/Idus_out_stock',
      name: 'Idus_out_stock',
      component: Idus_out_stock
    }
    ,
    {
      path: '/S_out_stock',
      name: 'S_out_stock',
      component: S_out_stock
    }
    ,
    {
      path: '/S_stock',
      name: 'S_stock',
      component: S_stock
    }
    ,
    {
      path: '/Idus_stock',
      name: 'Idus_stock',
      component: Idus_stock
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js